/* eslint-disable */
import React from 'react';
import { messages } from '../../common/messages';
import { Col, Row } from 'reactstrap';

const VideoPlayListView = ({
  videoTitle = '',
  currentIndex = 0,
  videosData = [],
  youtubeID = '',
  navigateToVideoByID,
  isUserSubscribed,
  toggleAlert,
}) => {
  return (
    <div>
      <div className='video_outer'>
        <Row>
          <Col xs={12} sm={8} md={8}>
            <h5 className='mb-0'>{videoTitle}</h5>
          </Col>
          <Col xs={12} sm={4} md={4} className='mb-2'>
            <div className='float-right text-right'>
              {parseInt(currentIndex, 10) === 0 ? null : (
                <i
                  className='fa fa-angle-left ques_arrow pointer_class'
                  onClick={() => navigateToVideoByID(parseInt(currentIndex, 10) - 1)}
                />
              )}
              {parseInt(currentIndex, 10) === videosData.length - 1 ? null : (
                <i
                  className='fa fa-angle-right ques_arrow pointer_class'
                  onClick={() => navigateToVideoByID(parseInt(currentIndex, 10) + 1)}
                />
              )}
            </div>
          </Col>
        </Row>

        <Row className='videos-main-wraper p-0'>
          <Col xs={12} sm={9} md={9} className='video-show-section'>
            <div id='video-height'>
              <div className='embed-responsive embed-responsive-16by9'>
                {videosData[currentIndex].url_id_qq ? (
                  <iframe
                    width='100%'
                    allowFullScreen='1'
                    height='100%'
                    src={`//ljsp.lwcdn.com/api/video/embed.jsp?id=${
                      videosData[currentIndex].url_id_qq
                    }&pi=080de783-b4bf-4b42-ac09-e782c8a907ef`}
                    sandbox='allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation'
                    frameBorder='0'
                    title='0'
                  />
                ) : (
                  <iframe
                    className='embed-responsive-item'
                    width='100%'
                    height='100%'
                    title='video'
                    frameBorder='0'
                    src={`https://www.youtube.com/embed/${youtubeID}?wmode=opaque&amp;rel=0&amp;autohide=1&amp;showinfo=0&amp;wmode=transparent&amp;modestbranding=1 `}
                    allowFullScreen
                    sandbox='allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation'
                  />
                )}
              </div>
            </div>
          </Col>
          <Col xs={12} sm={3} md={3} className='video-tag-heading' id='video-tag-list'>
            <div className='link_list_wrap height-571'>
              {videosData.map((item, index) => (
                <div key={item.id}>
                  <div className='full-width' key={item.id}>
                    <div className='videotitle' key={item.id} value={item.id}>
                      {!isUserSubscribed &&
                        (item.free ? (
                          <div className='video-type-free'>{messages.FREE}</div>
                        ) : (
                          <div className='video-type-primum'>{messages.PREMIUM}</div>
                        ))}
                      <button
                        type='button'
                        name='videourl'
                        id={item.id}
                        className={item.url_id === youtubeID ? 'active' : ''}
                        onClick={() => {
                          if (!isUserSubscribed && !item.free) return toggleAlert();
                          navigateToVideoByID(index);
                        }}
                        value={item.url}
                      >
                        <i className='fa fa-play-circle' />
                        <div className='text-overflow'>{item.title}</div>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default VideoPlayListView;



// WEBPACK FOOTER //
// ./src/Components-2025/Videos/VideoPlayList.jsx